/* eslint-disable */
import { all, call } from 'redux-saga/effects';
import confirmCredentialsSaga from './confirm-credentials';

const userSaga = function* () {
    yield all([call(confirmCredentialsSaga)]);
};

export default userSaga;
